import { canv } from "@/canv/global.js";
import { eventEmitter } from "@/eventEmitter";
import { toolBase } from "@/tools/toolBase";

export class TemplatesTool extends toolBase {
    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 12H20M14 16H20M14 20H20M4 5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V7C20 7.26522 19.8946 7.51957 19.7071 7.70711C19.5196 7.89464 19.2652 8 19 8H5C4.73478 8 4.48043 7.89464 4.29289 7.70711C4.10536 7.51957 4 7.26522 4 7V5ZM4 13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12H9C9.26522 12 9.51957 12.1054 9.70711 12.2929C9.89464 12.4804 10 12.7348 10 13V19C10 19.2652 9.89464 19.5196 9.70711 19.7071C9.51957 19.8946 9.26522 20 9 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V13Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    TryAction(type: string) {
        if (type === "mousedown") {
            canv.toolBox.switchToByName("templatesTool");
        }
    }

    select() {
        super.select();
        eventEmitter.dispatch("templateToolMenu.visibility", { isVisible: true });
    }

    unselect() {
        super.unselect();
        eventEmitter.dispatch("templateToolMenu.visibility", { isVisible: false });
    }

    getToolTipName() {
        return "Шаблоны";
    }

    name = "templatesTool";
}
